<!--
---
--- Navigation Drawer for the Application
----->
<template>
  <v-navigation-drawer
    v-model="drawerModel"
    :clipped="drawerClipped"
    :fixed="drawerFixed"
    :permanent="false"
    enable-resize-watcher
  >
    <v-list nav dense color="primary">

      <!-- Master Data -->
      <v-list-group class="my-navigator-lg" value="MasterData" v-if="this.authorityHelper.hasRoleAdmin()">
        <template v-slot:activator="{ props }">
          <v-list-item class="customPrependGroup" v-bind="props" prepend-icon="md:perm_data_setting" :title="$t('message.masterData')"></v-list-item>
        </template>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setPLState(true)" prepend-icon="md:analytics" :title="$t('message.plliste')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item v-show="!this.$store.getters.isSAP" class="my-navigator-lg-item customPrependItem" @click="entityHelper.setCustomerWarehouseState(true)" :prepend-icon="dataWarehouseIcon" :title="$t('message.plCustomerWarehouse')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setUserState(true)" prepend-icon="mdi-account-box" :title="$t('message.customerData')"></v-list-item>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setDataTargetState(true)" :prepend-icon="targetIcon" :title="$t('message.targetData')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setOrderState(true)" :prepend-icon="orderIcon" :title="$t('message.orderData')"></v-list-item>
      </v-list-group>

      <v-list-group v-if="!this.authorityHelper.hasRoleAdmin()" class="my-navigator-lg" value="MaterData">
        <template v-slot:activator="{ props }">
          <v-list-item class="customPrependGroup" v-bind="props" prepend-icon="md:perm_data_setting" :title="$t('message.masterData')"></v-list-item>
        </template>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setPLState(true)" prepend-icon="md:analytics" :title="$t('message.plliste')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setUserState(true)" prepend-icon="mdi-account-box" :title="$t('message.user_username')"></v-list-item>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="entityHelper.setOrderState(true)" :prepend-icon="orderIcon" :title="$t('message.orderData')"></v-list-item>
      </v-list-group>

      <!-- reporting -->
      <v-list-group v-if="this.authorityHelper.hasRoleAdmin()" class="my-navigator-lg" value="Reporting">
        <template v-slot:activator="{ props }">
          <v-list-item class="customPrependGroup" v-bind="props" prepend-icon="mdi-receipt-text-outline" :title="$t('message.reporting')"></v-list-item>
        </template>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="showReport('WebZugriffePulverAS400',$t('message.usageReport'),'maindb')" :prepend-icon="reportIcon" :title="$t('message.usageReport')"></v-list-item>
        <v-list-item class="my-navigator-lg-item customPrependItem" @click="showReport('WebZugriffePulver',$t('message.usageReportOld'),'sybase')" :prepend-icon="reportIcon" :title="$t('message.usageReportOld')"></v-list-item>
      </v-list-group>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import WebService from "@/plugins/WebService";
import AuthorityHelper from "@/plugins/AuthorityHelper";
import UtilityHelper from "@/plugins/UtilityHelper";
import EntityHelper from "@/plugins/EntityHelper";

export default {
  name: "pl-navigation-drawer",

  data: () => ({
    reportIcon: 'mdi-file-pdf-box',
    dataWarehouseIcon: 'mdi-hexagon-slice-6',
    targetIcon: 'mdi-target-account',
    orderIcon: 'mdi-shopping-search',

    drawerClipped: false,
    drawerFixed: false,
    drawerMini: false,
    masterDataActive: false,

    webService: null,
    authorityHelper: null,
    utilityHelper: null,
    entityHelper: null
  }),

  created() {
    this.webService = new WebService(this);
    this.authorityHelper=new AuthorityHelper(this);
    this.utilityHelper = new UtilityHelper(this);
    this.entityHelper = new EntityHelper(this);
  },

  computed: {
    drawerModel: {
      get() {
        return this.$store.state.navigationDrawer.drawer;
      },

      set(value) {
        this.$store.dispatch("setNavigationDrawer", value);
      }
    }
  },

  methods: {
    // toggles the drawer variant (mini/full)
    toggleMiniDrawer() {
      this.drawerMini = !this.drawerMini;
      if (this.drawerMini) {
        this.masterDataActive = false;
      }
    },

    // toggles the drawer type (permanent vs temporary) or shows/hides the drawer
    toggleDrawer() {
      if (this.drawerPermanent) {
        this.drawerPermanent = !this.drawerPermanent;
        // set the clipped state of the drawer and toolbar
        this.drawerClipped = true;
        this.toolbarClippedLeft = true;
      } else {
        // normal drawer
        this.drawerOpen = !this.drawerOpen;
      }
    },

    showReport(reportName,reportTitle,reportDataSource)
    {
      this.$store.dispatch("setReport", { showReport: true, name: reportName, title: reportTitle,
        reportData: {
          dataSource: reportDataSource,
          name: reportName,
          outputType: "HTML",
          inputType: "LIST",
          parameters: [],
          dataSets: []
        }
      });
    }

  },

  watch: {
    // if we activate the master data we do not allow mini drawers
    masterDataActive: {
      immediate: true,
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal) {
          this.drawerMini = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.customPrependGroup :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 20px;
}
.customPrependItem :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 5px;
}

.my-navigator >>> label {
  font-size: 12px;
  left: 100px;
  color: black;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.my-navigator >>> .v-input--radio-group__input {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 70px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.my-navigator >>> .v-list__group__items {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 70px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.v-input.my-navigator {
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.my-navigator-lg {
  position: relative;
  left: -10px;
}

.my-navigator-lg-item {
  position: relative;
  left: -40px;
}

.my-navigator-cb {
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  height: 30px;
}

.my-spacer {
  min-width: 10%;
}
.my-badge {
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 600;
  line-height: 23px;
  background: darkblue;
  color: white;
  height: 30px;
  border-radius: 100%;
  padding-left: 4px;
  padding-right: 4px;
}

.my-icon {
  padding-left: 40px;
}
</style>